import { Text } from '@mantine/core';

interface SettingTitleProps {
  title: string;
  description?: string;
}

export function SettingTitle({ title, description }: SettingTitleProps) {
  return (
    <>
      <Text fw={600}>{title}</Text>
      {description && <Text c='gray.6'>{description}</Text>}
    </>
  );
}
